/**
 * Created by 1 on 2017/11/23.
 * 图层选取元素的组件
 */
'use strict';
define([
	'../base/PureComponent',
	'../utils/LayerUtil',
	'../utils/CommonUtil',
	'../g2'
], function(
	PureComponent,
	LayerUtil,
	CommonUtil,
	g2
) {
	/**
	 * @constructor
	 * @classdesc 地图选取要素组件
	 * @alias G.components.SelectionComponent
	 * @augments G.base.PureComponent
	 * @param options {Object} 必填
	 * @param options.map {G.Map} 必填，地图对象
	 * @param options.matchingLayer {Array} 必填，需要被选取要素的图层数组
	 * @param options.selectionLayer {String} 可选，选取要素图层id，不传自动创建新图层
	 */
	var component = PureComponent.extend({
		options: {},
		initialize: function(options) {
			PureComponent.prototype.initialize.call(this, options);
			//创建一个画选取框的图层
			var g2Map = this.map.getMap();
			this.options.selectionLayer = this.options.selectionLayer || CommonUtil.newUUID32();
			var layer = LayerUtil.getLayerById(this.map, this.options.selectionLayer);
			if(!layer) {
				layer = new g2.carto.ElementLayer({
					id: this.options.selectionLayer,
					map: g2Map
				});
				g2Map.addLayer(layer);
			}
			//创建的框选图层
			this._layer = layer;
			//传入的要匹配的图层
			this._matchingLayer = this.options.matchingLayer;
		},
		/**
		 * 销毁
		 * @method
		 */
		destroy: function() {
			//移除框选要素的图层
			this.map.getMap().removeLayer(this._layer)
			PureComponent.prototype.destroy.call(this);
		}
	})
	//对外提供方法
	component.include({
		/**
		 * 点选匹配要素
		 * @method
		 * @memberOf G.components.SelectionComponent.prototype
		 * */
		pointMatchingElement: function() {
			var self = this;
			var layerArr = this._matchingLayer;
			if(layerArr.length > 0) {
				this.map.listen("click", function(options) {
					for(var i = 0; i < layerArr.length; i++) {
						var graphic = layerArr[i].hitTest(options.screenX, options.screenY);
						if(!!graphic) {
							graphic.layer = layerArr[i];
							var element = graphic.element;
							self.fire('pointMatchingElement', element);
						}
					}
				})

			}
		},
		/**
		 * 矩形框选地图要素
		 * @method
		 * @memberOf G.components.SelectionComponent.prototype
		 * @param topologicalType {String} 选填，拓扑类型 例：contains(包含)，intersects(相交)
		 * */
		squareMatchingElement: function(topologicalType) {
			var self = this;
			//先停止地图拖拽和放大缩小
			this.map.getMap().stopDragPan();
			this.map.getMap().stopMouseWheelZoom();
			var startX, startY, endX, endY, element;
			//map监听鼠标拖动事件
			this._mapMousemove = function(options) {
				endX = options.mapX;
				endY = options.mapY;
				//开始画矩形
				var options = {
					startX: startX,
					startY: startY,
					endX: endX,
					endY: endY
				}
				element = self._drawSquare(options)
			}
			//map监听鼠标按下事件
			this._mapMousedown = function(options) {
				startX = options.mapX;
				startY = options.mapY;
				self.map.listen("mousemove", self._mapMousemove);
			}
			//map监听鼠标抬起事件
			this._mapMouseup = function(options) {
				self.map.off("mousedown", self._mapMousedown);
				self.map.off("mousemove", self._mapMousemove);
				self.map.off("mouseup", self._mapMouseup);
                self.map.resumeDragPan();
                self.map.resumeMouseWheelZoom();

				//返回框选的数据
				var elementArray = LayerUtil.selectElementOnMap(element.geometry, self._matchingLayer, topologicalType);
				self.fire('squareMatchingElement', elementArray);
			}
			this.map.listen("mouseup", this._mapMouseup);
			this.map.listen("mousedown", this._mapMousedown);
		},
		/**
		 * 取消框选
		 * @method
		 * @memberOf G.components.SelectionComponent.prototype
		 * */
		cancelSelection: function() {
			this.map.off("mousedown", self._mapMousedown);
			this.map.off("mousemove", self._mapMousemove);
			this.map.off("mouseup", self._mapMouseup);
			this.map.resumeDragpan();
			this.map.resumeMouseWheelZoom();
		},
		/**
		 * 清除框选
		 * @method
		 * @memberOf G.components.SelectionComponent.prototype
		 * */
		clearSelection: function() {
			//删除绘制的框选图形
			this._layer.clear();
		}
	})
	//内部调用方法
	component.include({
		/**
		 * 画矩形
		 * */
		_drawSquare: function(options) {
			var firstPoint = new g2.sfs.Point({ x: options.startX, y: options.startY, spatialReference: this.map.spatialReference }),
				twoPoint = new g2.sfs.Point({ x: options.endX, y: options.startY, spatialReference: this.map.spatialReference }),
				threePoint = new g2.sfs.Point({ x: options.endX, y: options.endY, spatialReference: this.map.spatialReference }),
				fourPoint = new g2.sfs.Point({ x: options.startX, y: options.endY, spatialReference: this.map.spatialReference }),
				symbol = new g2.sfs.SimpleFillSymbol({
					fillColor: g2.sfs.Color.fromHex("#44ffffff"),
					borderColor: g2.sfs.Color.fromHex("#000"),
					borderThickness: 1,
					style: 5
				}),
				ring = new g2.sfs.Ring({ spatialReference: this.map.spatialReference }),
				polygon = new g2.sfs.Polygon({ spatialReference: this.map.spatialReference });
			ring.addPoint(firstPoint);
			ring.addPoint(twoPoint);
			ring.addPoint(threePoint);
			ring.addPoint(fourPoint);
			ring.addPoint(firstPoint);
			polygon.addGeometry(ring);
			var element;
			if(this._layer.find("selectSquare")) {
				element = this._layer.find("selectSquare");
				element.geometry = polygon;
				this._layer.remove(element);
				this._layer.add(element);
			} else {
				element = new g2.sfs.Element({ id: "selectSquare", geometry: polygon, symbol: symbol });
				this._layer.add(element)
			}
			return element;
		}
	})
	return component;
})
